const INTEGER_PATTERN = /^\d+$/;

export function splitBpn(bpn, separator) {
  return (bpn ?? '').split(separator);
}

// For each part index, determine whether every BPN in the list has a purely
// integer value at that position (numeric sort) or not (alphabetical sort)
function numericPartFlags(bpns, separator) {
  const allParts = bpns.map(bpn => splitBpn(bpn, separator));
  const maxLength = Math.max(0, ...allParts.map(parts => parts.length));
  const flags = [];
  for (let i = 0; i < maxLength; i++) {
    flags.push(
      allParts.every(parts => i < parts.length && INTEGER_PATTERN.test(parts[i]))
    );
  }
  return flags;
}

// Sorts items by BPN, comparing parts left to right. Each part is sorted
// numerically if all items have integer values there, else alphabetically.
// Items without a BPN have no pickable location, so they always sort last
export function sortItemsByBpn(items, separator, direction) {
  const flags = numericPartFlags(
    items.map(item => item.bpn ?? ''),
    separator
  );
  const sign = direction === 'asc' ? 1 : -1;

  return [...items].sort((a, b) => {
    const hasA = (a.bpn ?? '') !== '';
    const hasB = (b.bpn ?? '') !== '';
    if (hasA !== hasB) return hasA ? -1 : 1;

    const partsA = splitBpn(a.bpn, separator);
    const partsB = splitBpn(b.bpn, separator);
    const length = Math.max(partsA.length, partsB.length);
    for (let i = 0; i < length; i++) {
      const partA = partsA[i];
      const partB = partsB[i];
      if (partA === undefined) return -sign;
      if (partB === undefined) return sign;
      const cmp = flags[i]
        ? Number(partA) - Number(partB)
        : partA.localeCompare(partB);
      if (cmp !== 0) return cmp * sign;
    }
    return 0;
  });
}
